import React from "react"
import { Link } from "react-router-dom"
import moment from "moment"
import numeral from "numeral"

const ExpenseListItem = ({ id, description, label = "", note = "", amount, createdAt }) => (
  <div>
    &nbsp;&nbsp;
    <Link className="list-item--link" title="Repeat this expense" to={`/copy/${id}`}>
      <span>Add Expense</span>
    </Link>
    <Link className="list-item" to={`/edit/${id}`}>
      <div>
        &nbsp;
        <h3 className="list-item__title">{description}</h3>
        <span className="list-item__sub-title">{moment(createdAt).format("MMMM Do, YYYY")}</span>
        <span className="list-item__sub-title">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{label.toLowerCase()}</span>
        <span className="list-item__sub-title">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{note.substring(0, 20)}</span>
      </div>
      <h3 className="list-item__data">{numeral(amount / 100).format("$0,0.00")}</h3>
    </Link>
  </div>
)

export default ExpenseListItem



// WEBPACK FOOTER //
// ./src/components/ExpenseListItem.js